<template>
    <div>
        <div class="frame">
            <div style="display:flex; position: relative;">
                <div style="display: flex; flex: 1; justify-content: end; position: relative; z-index: 2;">
                    <ScrollSelectorNew test="시" textLeft="72.5%" :transformX="25" :list="hours" style="height:200px; overflow:hidden; flex: 1;" :init-value='initHour' :detect-value-change="detectHourChange"></ScrollSelectorNew>
                </div>
                <div style="flex: 1; display: flex; position: relative; justify-content: start; position: relative; z-index: 2;">
                    <ScrollSelectorNew test="분" textLeft="34%" :transformX="-45" :list="mins" style="height:200px; overflow:hidden; flex: 1;" :init-value="initMin" :detect-value-change="detectMinChange"></ScrollSelectorNew>
                </div>
                <div style="background-color: #f5f5f5; width: calc(100% - 40px); z-index: 1; border-radius: 7px; height: 30px; position: absolute; left: 50%;top: 50%; transform: translate(-50%, -50%); "></div>
            </div>
        </div>
        <div style="">
            <div style="display: flex; gap: 12px; margin-top: 12px; justify-content: end;">
                <div @click="closeAction" style="width: 88px; height: 40px; line-height: 40px; text-align: center; border-radius: 10px; background-color: #444241; color: #fff;">취소</div>
                <div @click="confirm" style="width: 88px; height: 40px; line-height: 40px; text-align: center; border-radius: 10px; background-color: var(--color-main); color: #fff;">적용</div>
            </div>
        </div>
    </div>
</template>

<script>
import ScrollSelectorNew from "./ScrollSelectorNew";
import moment from 'moment';

export default {
    name: "TimeSelectorChat",
    components: { ScrollSelectorNew },
    props: {
        startTime: {
            type: String,
            default: '',
        },
        completeAction: {
            type: Function,
            default: () => { },
        },
        closeAction: {
            type: Function,
            default: () => { }
        }
    },
    watch: {

    },
    data() {
        return {
            hours: [],
            mins: [],
            initHour: '',
            initMin: '',
            selectedHour: '',
            selectedMin: '',
            reloadFlag: false,
        }
    },
    methods: {
        refresh() {
            this.hours = [
                { label: '00', value: '00' },
                { label: '01', value: '01' },
                { label: '02', value: '02' },
                { label: '03', value: '03' },
                { label: '04', value: '04' },
                { label: '05', value: '05' },
                { label: '06', value: '06' },
                { label: '07', value: '07' },
                { label: '08', value: '08' },
                { label: '09', value: '09' },
                { label: '10', value: '10' },
                { label: '11', value: '11' },
                { label: '12', value: '12' },
                { label: '13', value: '13' },
                { label: '14', value: '14' },
                { label: '15', value: '15' },
                { label: '16', value: '16' },
                { label: '17', value: '17' },
                { label: '18', value: '18' },
                { label: '19', value: '19' },
                { label: '20', value: '20' },
                { label: '21', value: '21' },
                { label: '22', value: '22' },
                { label: '23', value: '23' },
            ];
            this.mins = []

            const mins = [];

            // 분 단위 조정 i = i+5 => 5분단위 생성
            for (let i = 0; i <= 59; i = i + 5) {
                let minStr = i + '';
                if (i < 10) minStr = '0' + i;
                mins.push({ label: minStr, value: minStr });
            }

            this.mins = mins;

            if (this.startTime) {
                let hour = parseInt(this.startTime.substr(0, 2));
                this.initHour = (hour < 10) ? '0' + hour : hour + '';
                this.initMin = this.startTime.substr(3, 2);
            } else {
                moment()
                let hour = parseInt(moment().format('HH'));
                let min = parseInt(moment().format('mm'))
                if (min >= 58) {
                    hour += 1
                }
                this.initHour = (hour < 10) ? '0' + hour : hour + '';
                const roundedMin = Math.round(min / 5) * 5;
                this.initMin = (roundedMin < 10) ? '0' + roundedMin : roundedMin + '';
            }

        },
        detectHourChange(selectedData) {
            this.selectedHour = selectedData.value;
        },
        detectMinChange(selectedData) {
            this.selectedMin = selectedData.value;
        },
        confirm() {
            let timeStr = '';
            let hour = parseInt(this.selectedHour);
            if (hour < 10) hour = '0' + hour;

            timeStr = hour + ':' + this.selectedMin;
            this.completeAction(timeStr);
        },
        discuss() {
            this.completeAction('협의');
            this.hide();
        }

    },
    created() {
        this.refresh();
    }
}
</script>

<style scoped>
.frame {
    background-color: #efefef;
    padding-bottom: 20px;
    border-radius: 20px;
    font-weight: 500;
}
</style>